<template>
    <div>
        <div v-if="error" class="font-white">
            Page {{$route.params.id}} Not Found.<br/>{{errMsg}}
        </div>
        <div ref="display" class="border-red" style="box-sizing: border-box;width:100%;
		max-width: 1218px;margin:auto"></div>
    </div>
</template>

<script>
	import axios from 'axios';

	export default {
		name: "ReadMore",
		props: {
			baseURL: String,
			sub: String
		},
		data() {
			return {
				subURL: '',
				errMsg: '',
				error: false,
				json: null
			}
		},
		methods: {
			url(v) {
				return this.subURL + v;
			},
			renderBlock(data) {
				let html = "";
				if (data.svg) {
					html += "<object data='" + this.url(data.svg) + "' type=\"image/svg+xml\" style='width:100%'></object>";
				} else if (data.img) {
					html += "<img style='width:100%' src='" + this.url(data.img) + "'/>";
				} else if (data.quote) {
					html += "<div class='quote'>" + data.quote + "</div>";
				} else if (data.text) {
					html += "<div class='text'>" + data.text + "</div>";
				}
				return html;
			},
			render() {
				const data = this.json.content;
				const display = this.$refs.display;
				let html = "";
				for (let i = 0; i < data.length; i++) {
					let tr = data[i];
					if (tr.length > 1) {
						html+="<div style='width:100%;'>";
						for (let j = 0; j < tr.length; j++) {
							html += "<div style='width:100%;max-width: 600px;min-width: 300px;display:inline-block;"+(j!==0?"padding:0px 6px 0px 6px":"")+"'>" + this.renderBlock(tr[j]) + "</div>";
						}
						html+="</div>";
					} else {
						html += "<div style='width:100%'>" + this.renderBlock(tr[0]) + "</div>";
					}
				}
				display.innerHTML = html;
			}
		},
		mounted() {
			this.subURL = this.baseURL + this.sub + "/" + this.$route.params.id + "/";
			axios
				.get(this.subURL + 'details.json', {
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json"
					},
					method: "GET",
					mode: "cors"
				})
				.then(response => {
					this.json = response.data;
					this.render();
				})
				.catch(err => {
					this.error = true;
					this.errMsg = err;
				});
		}
	}
</script>

<style scoped>

</style>